"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Ribbon = _interopRequireDefault(require("../../atoms/Ribbon"));
var _Title = _interopRequireDefault(require("../../atoms/Title"));
var _Button = _interopRequireDefault(require("../../atoms/Button"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".TitleLockup__description {\n  font-weight: 400;\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n@media (max-width: 25.9375rem) {\n  .TitleLockup__description {\n    font-size: 1rem;\n    line-height: 1.5rem;\n    text-align: center;\n  }\n}\n@media (max-width: 25.9375rem) {\n  .TitleLockup__title {\n    text-align: center;\n  }\n}\n@media (max-width: 25.9375rem) {\n  .TitleLockup__button {\n    display: none;\n  }\n}\n@media (max-width: 25.9375rem) {\n  .TitleLockup {\n    max-width: 21.5rem;\n  }\n}\n@media (min-width: 48.0625rem) {\n  .TitleLockup {\n    max-width: 43rem;\n  }\n}\n@media (min-width: 75.0625rem) {\n  .TitleLockup {\n    max-width: 37.5rem;\n  }\n}";
  var fileName = "TitleLockup_TitleLockup";
  var element = document.querySelector("style[data-sass-component='TitleLockup_TitleLockup']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
/**
 * A large title section that includes a ribbon, button, and short description.
 */
var TitleLockup = function TitleLockup(_ref) {
  var children = _ref.children,
    title = _ref.title,
    ribbonText = _ref.ribbonText,
    buttonText = _ref.buttonText,
    buttonProps = _ref.buttonProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "TitleLockup",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Ribbon["default"], {
      className: "MB-1",
      children: ribbonText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Title["default"], {
      className: "TitleLockup__title MB-1",
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "TitleLockup__description MB-1H",
      children: children
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], _objectSpread(_objectSpread({}, buttonProps), {}, {
      className: "TitleLockup__button MB-1",
      children: buttonText
    }))]
  });
};
var _default = TitleLockup;
exports["default"] = _default;